import { calculateAge as e, calculateAge as t, contactValidation as n, dateOnlyToISO as r, localCalendarDateTodayISO as i, parseFhirInstantForDisplay as a, parseFhirInstantForDisplay as o, toDateInputValue as s } from "@benchmark/core/utils";
// src/utils/date-utils.ts
function c(e) {
	if (typeof e == "string") {
		if (e.includes("T")) {
			let t = e.split("T")[0], n = e.split("T")[1];
			if (n === "00:00:00Z" || n?.startsWith("00:00:00")) {
				let [e, n, r] = t.split("-").map(Number);
				if (!isNaN(e) && !isNaN(n) && !isNaN(r) && e > 0 && n >= 1 && n <= 12 && r >= 1 && r <= 31) return new Date(e, n - 1, r);
			}
			let r = new Date(e);
			return isNaN(r.getTime()) ? new Date(1900, 0, 1) : new Date(r.getFullYear(), r.getMonth(), r.getDate());
		}
		let t = /* @__PURE__ */ new Date(e + "T00:00:00");
		return isNaN(t.getTime()) ? new Date(1900, 0, 1) : new Date(t.getFullYear(), t.getMonth(), t.getDate());
	}
	return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function l() {
	return c(/* @__PURE__ */ new Date());
}
function u(e) {
	let t = l(), n = c(e);
	return n.getFullYear() === t.getFullYear() && n.getMonth() === t.getMonth() && n.getDate() === t.getDate();
}
function d(e) {
	let t = l(), n = c(e);
	return n.getFullYear() < t.getFullYear() ? !0 : n.getFullYear() > t.getFullYear() ? !1 : n.getMonth() < t.getMonth() ? !0 : n.getMonth() > t.getMonth() ? !1 : n.getDate() < t.getDate();
}
function f(e) {
	let t = l();
	t.setDate(t.getDate() + 1);
	let n = c(e);
	return n.getFullYear() === t.getFullYear() && n.getMonth() === t.getMonth() && n.getDate() === t.getDate();
}
function p(e) {
	let t = l(), n = c(e);
	return n.getFullYear() > t.getFullYear() ? !0 : n.getFullYear() < t.getFullYear() ? !1 : n.getMonth() > t.getMonth() ? !0 : n.getMonth() < t.getMonth() ? !1 : n.getDate() > t.getDate();
}
function m(e, t = !1) {
	return !t && d(e);
}
function h(e, t) {
	let n = c(e), r = c(t).getTime() - n.getTime();
	return Math.ceil(r / 864e5);
}
// src/utils/datetime.ts
var g = {
	FULL_DATETIME: "fullDateTime",
	DATE_ONLY: "dateOnly",
	TIME_ONLY: "timeOnly",
	ISO_DATE: "isoDate",
	ISO_DATETIME: "isoDateTime",
	RELATIVE: "relative",
	AGE: "age"
};
function _(e, t = g.FULL_DATETIME, n = "en-US") {
	if (!e) return "";
	let r = typeof e == "string" ? a(e) : e;
	if (isNaN(r.getTime())) return "Invalid date";
	switch (t) {
		case g.FULL_DATETIME: return r.toLocaleDateString(n, {
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "numeric",
			minute: "2-digit",
			hour12: !0
		});
		case g.DATE_ONLY: return r.toLocaleDateString(n, {
			year: "numeric",
			month: "short",
			day: "numeric"
		});
		case g.TIME_ONLY: return r.toLocaleTimeString(n, {
			hour: "numeric",
			minute: "2-digit",
			hour12: !0
		});
		case g.ISO_DATE: return r.toISOString().split("T")[0];
		case g.ISO_DATETIME: return r.toISOString();
		case g.RELATIVE: return v(r);
		case g.AGE: return y(r);
		default: return r.toLocaleDateString(n);
	}
}
function v(e) {
	let t = (/* @__PURE__ */ new Date()).getTime() - e.getTime(), n = Math.floor(t / 6e4), r = Math.floor(t / 36e5), i = Math.floor(t / 864e5), a = Math.floor(i / 7), o = Math.floor(i / 30), s = Math.floor(i / 365), c = t < 0, l = c ? "in " : "", u = c ? "" : " ago", d = Math.abs(n), f = Math.abs(r), p = Math.abs(i), m = Math.abs(a), h = Math.abs(o), g = Math.abs(s);
	return d < 1 ? "just now" : d < 60 ? `${l}${d} minute${d === 1 ? "" : "s"}${u}` : f < 24 ? `${l}${f} hour${f === 1 ? "" : "s"}${u}` : p < 7 ? `${l}${p} day${p === 1 ? "" : "s"}${u}` : m < 4 ? `${l}${m} week${m === 1 ? "" : "s"}${u}` : h < 12 ? `${l}${h} month${h === 1 ? "" : "s"}${u}` : `${l}${g} year${g === 1 ? "" : "s"}${u}`;
}
function y(t) {
	let n = e(typeof t == "string" ? t : t.toISOString().split("T")[0]);
	return n === null ? "Unknown age" : `${n} year${n === 1 ? "" : "s"} old`;
}
function b(e) {
	let t = new Date(e);
	return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}T${String(t.getHours()).padStart(2, "0")}:${String(t.getMinutes()).padStart(2, "0")}`;
}
function x(e) {
	return new Date(e).toISOString();
}
var S = [
	"T12:00:00.000Z",
	"T23:59:59.999Z",
	"T00:00:00.000Z"
];
function C(e) {
	if (/^\d{4}-\d{2}-\d{2}$/.test(e) || S.some((t) => e.endsWith(t))) return !1;
	let t = new Date(e);
	return !Number.isNaN(t.getTime());
}
function w(e) {
	let t = e.match(/^(\d{4}-\d{2}-\d{2})/);
	if (t?.[1]) return t[1];
	let n = new Date(e);
	return Number.isNaN(n.getTime()) ? "" : `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
}
// src/utils/form-validation.ts
var T = {
	required: (e = "This field") => (t) => !t || typeof t == "string" && t.trim() === "" ? `${e} is required` : null,
	phone: (e = !1) => (t) => !t || t.trim() === "" ? e ? "Phone number is required" : null : n.isValidPhone(t) ? null : "Please enter a valid phone number",
	email: (e = !1) => (t) => !t || t.trim() === "" ? e ? "Email address is required" : null : n.isValidEmail(t) ? null : "Please enter a valid email address",
	url: (e = !1) => (t) => !t || t.trim() === "" ? e ? "URL is required" : null : n.isValidUrl(t) ? null : "Please enter a valid URL",
	pastDate: (e = "Date") => (t) => {
		if (!t) return null;
		let n = /^\d{4}-\d{2}-\d{2}$/.test(t);
		if (n && t > i()) return `${e} cannot be in the future`;
		let r = n ? o(t) : new Date(t);
		return isNaN(r.getTime()) ? "Invalid date format" : !n && r > /* @__PURE__ */ new Date() ? `${e} cannot be in the future` : null;
	},
	date: (e = !1, t = "Date") => (n) => {
		if (!n || n.trim() === "") return e ? `${t} is required` : null;
		let r = /^\d{4}-\d{2}-\d{2}$/.test(n) ? o(n) : new Date(n);
		return isNaN(r.getTime()) ? "Invalid date format" : null;
	},
	zipCode: (e = !1) => (t) => !t || t.trim() === "" ? e ? "ZIP code is required" : null : /^\d{5}(-\d{4})?$/.test(t) ? null : "Please enter a valid ZIP code (e.g., 12345 or 12345-6789)",
	minLength: (e, t = "This field") => (n) => n && n.length < e ? `${t} must be at least ${e} characters long` : null,
	maxLength: (e, t = "This field") => (n) => n && n.length > e ? `${t} must be no more than ${e} characters long` : null,
	combine: (...e) => (t) => {
		for (let n of e) {
			let e = n(t);
			if (e) return e;
		}
		return null;
	}
}, E = {
	validateContactValue: (e, t) => {
		if (!e || e.trim() === "") return null;
		switch (t) {
			case "phone":
			case "fax": return T.phone(!1)(e);
			case "email": return T.email(!1)(e);
			case "url": return T.url(!1)(e);
			default: return null;
		}
	},
	requirePhoneOrEmail: (e, t) => {
		let n = e && e.trim() !== "", r = t && t.trim() !== "";
		return !n && !r ? "Either phone number or email address is required" : null;
	}
};
export { f as C, u as S, h as _, r as a, m as b, b as c, v as d, i as f, c as g, s as h, t as i, _ as l, o as m, E as n, C as o, w as p, g as r, y as s, T as t, x as u, l as v, d as x, p as y };

//# sourceMappingURL=form-validation-DWYCe0I8.js.map